import { fontFamily } from "@/theme";

const inter = fontFamily.inter;

export const styles = {
  page: {
    width: "100%",
    bgcolor: "#fff",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    fontFamily: inter,
  },

  header: {
    width: "100%",
    height: "54px",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    px: "16px",
  },
  badge: (variant: "comingSoon" | "premium") => ({
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    borderRadius: "20px",
    padding: "5px 13px 5px 11px",
    border: "1px solid",
    whiteSpace: "nowrap",
    ...(variant === "comingSoon"
      ? { bgcolor: "#fef3c7", borderColor: "#fde68a", color: "#92400e" }
      : { bgcolor: "#2a85ff", borderColor: "#005fdf", color: "#fff" }),
  }),
  badgeIcon: { width: "10px", height: "10px", display: "block" },
  badgeText: {
    fontFamily: inter,
    fontWeight: 600,
    fontSize: "12px",
    lineHeight: "16px",
    textTransform: "uppercase",
  },

  heroSection: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "44px",
    px: "16px",
    pt: "44px",
    pb: "14px",
  },
  heroText: {
    width: "738px",
    maxWidth: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "22px",
  },
  heroTitle: {
    fontFamily: inter,
    fontWeight: 800,
    fontSize: "62px",
    lineHeight: "64px",
    letterSpacing: "-0.5px",
    color: "#2a2d31",
  },
  heroSubtitle: {
    fontFamily: inter,
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "22px",
    color: "#9da6b0",
  },

  pitchBanner: {
    position: "relative",
    width: "100%",
    height: "178px",
    borderRadius: "14px",
    overflow: "hidden",
  },
  bannerBg: {
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    display: "block",
  },
  pitchContent: {
    position: "relative",
    zIndex: 1,
    pt: "36px",
    px: "40px",
    display: "flex",
    flexDirection: "column",
  },
  bannerLabel: {
    fontFamily: inter,
    fontWeight: 600,
    fontSize: "12px",
    lineHeight: "16px",
    textTransform: "uppercase",
    color: "rgba(255,255,255,0.55)",
  },
  pitchHeading: {
    mt: "12px",
    fontFamily: inter,
    fontWeight: 700,
    fontSize: "30px",
    lineHeight: "39px",
    letterSpacing: "-0.4px",
    color: "#fff",
  },
  pitchHeadingAccent: { color: "#36c9fd" },

  section: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "32px",
    px: "16px",
    pt: "44px",
    pb: "14px",
  },
  sectionHead: { display: "flex", flexDirection: "column", gap: "10px" },
  sectionLabelRow: { display: "flex", alignItems: "center", gap: "6px" },
  sectionLabelLine: { width: "34px", height: "1px", bgcolor: "#d9d9d9" },
  sectionLabelText: {
    fontFamily: inter,
    fontWeight: 600,
    fontSize: "13px",
    lineHeight: "18px",
    color: "#7d8690",
  },
  sectionTitle: {
    fontFamily: inter,
    fontWeight: 700,
    fontSize: "30px",
    lineHeight: "42px",
    letterSpacing: "-0.6px",
    color: "#383c40",
  },

  awardsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    gap: "12px",
  },
  awardCard: (highlighted: boolean) => ({
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    borderRadius: "12px",
    ...(highlighted
      ? {
          p: "22px",
          border: "2px solid #2a85ff",
          background: "linear-gradient(116.5deg, #2a85ff 7%, #6da6f1 100%)",
        }
      : { p: "21.5px", border: "1.5px solid #e5e7eb", bgcolor: "#f7f9fb" }),
  }),
  awardIconBox: (highlighted: boolean) => ({
    width: "36px",
    height: "36px",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    ...(highlighted ? { bgcolor: "#fff", border: "1px solid #8bc5f4" } : { bgcolor: "#2a85ff" }),
  }),
  awardIcon: { width: "22px", height: "22px", display: "block" },
  awardTextWrap: { display: "flex", flexDirection: "column", gap: "4px" },
  awardTitle: (highlighted: boolean) => ({
    fontFamily: inter,
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "16px",
    color: highlighted ? "#fff" : "#0f1117",
  }),
  awardDesc: (highlighted: boolean) => ({
    fontFamily: inter,
    fontWeight: 500,
    fontSize: "12px",
    lineHeight: "16px",
    color: highlighted ? "#fff" : "#7d8690",
  }),

  stepsRow: { display: "flex", gap: "24px", width: "100%" },
  stepCard: {
    flex: "1 1 0",
    minWidth: 0,
    height: "173px",
    borderRadius: "12px",
    border: "1.5px solid #e5e7eb",
    bgcolor: "#f7f9fb",
    p: "15.5px",
    position: "relative",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
  },
  stepInner: {
    position: "relative",
    zIndex: 1,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  stepTitle: {
    fontFamily: inter,
    fontWeight: 700,
    fontSize: "20px",
    lineHeight: "28px",
    letterSpacing: "-0.45px",
    color: "#0f1117",
  },
  stepDesc: {
    fontFamily: inter,
    fontWeight: 500,
    fontSize: "12px",
    lineHeight: "16px",
    color: "#7d8690",
  },
  stepNumber: (isFirst: boolean) => ({
    position: "absolute",
    top: isFirst ? "-17.47px" : "-18.47px",
    right: isFirst ? "55.5px" : "77.5px",
    transform: "translateX(100%)",
    fontFamily: inter,
    fontWeight: 900,
    fontSize: "114px",
    lineHeight: "normal",
    color: "#e4f0ff",
    zIndex: 0,
    userSelect: "none",
    whiteSpace: "nowrap",
  }),

  statsWrap: { width: "100%", px: "16px", py: "14px" },
  statsBanner: {
    position: "relative",
    overflow: "hidden",
    width: "100%",
    display: "flex",
    borderRadius: "18px",
    py: "30px",
    bgcolor: "#2a85ff",
  },
  statsBg: {
    position: "absolute",
    top: "50%",
    left: 0,
    width: "100%",
    height: "178px",
    transform: "translateY(-50%)",
    display: "block",
  },
  statCol: (divided: boolean) => ({
    flex: "1 1 0",
    minWidth: 0,
    height: "94px",
    position: "relative",
    zIndex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "16px",
    px: "21px",
    textAlign: "center",
    ...(divided
      ? {
          borderLeft: "1px solid #f5f5f5",
          borderRight: "1px solid #f5f5f5",
        }
      : {}),
  }),
  statValue: {
    fontFamily: inter,
    fontWeight: 800,
    fontSize: "52px",
    lineHeight: "40px",
    letterSpacing: "-1px",
    color: "#fff",
  },
  statLabel: {
    fontFamily: inter,
    fontWeight: 700,
    fontSize: "13px",
    lineHeight: "16px",
    textTransform: "uppercase",
    color: "#fff",
  },
};
